import { useState } from 'react';
import { warehouseApi as api, apiError, operationKey } from '../shared/warehouseApi';

export function WarehouseSetup({ onSaved }) {
  const [open, setOpen] = useState(false);
  const [code, setCode] = useState('');
  const [name, setName] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const [key] = useState(operationKey);
  async function submit(e) {
    e.preventDefault(); setBusy(true); setError('');
    try { await api.post('/api/admin/warehouse/warehouses', { code, name }, { headers: { 'Idempotency-Key': key } }); setOpen(false); onSaved(); }
    catch (err) { setError(apiError(err)); }
    finally { setBusy(false); }
  }
  if (!open) return <button onClick={() => setOpen(true)} className="border rounded p-2 text-sm">Agregar bodega</button>;
  return <form onSubmit={submit} className="flex min-w-0 flex-wrap gap-2 border rounded p-3 bg-white [&_input]:min-w-0 [&_input]:w-full sm:[&_input]:w-auto sm:[&_input]:flex-1">
    <input aria-label="Código de bodega" placeholder="Código (LIM-01)" required maxLength={40} value={code} onChange={e => setCode(e.target.value)} className="border rounded p-2"/>
    <input aria-label="Nombre de bodega" placeholder="Nombre de bodega" required maxLength={120} value={name} onChange={e => setName(e.target.value)} className="border rounded p-2"/>
    <button disabled={busy} className="bg-brand-primary text-white rounded p-2">Guardar bodega</button><button type="button" onClick={() => setOpen(false)} disabled={busy}>Cancelar</button>
    {error && <p role="alert" className="text-red-600 w-full">{error}</p>}
  </form>;
}
